import { DOCUMENTABLE_TYPE_MAP, OrderType } from './orders';
//#region Auth
export const AUTH_BASE_URL = '/auth';
export const LAGER_CURRENT_USER = `${AUTH_BASE_URL}/token/verify-current-user/`;
export const USER_REFRESH_TOKEN = `${AUTH_BASE_URL}/token/refresh/`;
export const USER_INVITE = `${AUTH_BASE_URL}/invitation/send/`;
//#endregion

//#region Payables
export const PAYABLES_BASE_URL = '/api/order';
export const PAYABLE = (payableId: number) =>
  `${PAYABLES_BASE_URL}/${payableId}/`;
export const PAYABLE_EVENTS_URL = (payableId: number, eventName: string) =>
  `${PAYABLES_BASE_URL}/${payableId}/sm_${eventName}/`;
export const PAYABLE_ERRORS_URL = (payableId: number, eventName: string) =>
  `${PAYABLES_BASE_URL}/${payableId}/sm_can_${eventName}/`;
export const PAYABLE_ALLOWED_CURRENCIES = `${PAYABLES_BASE_URL}/allowed-currencies/`;
export const PAYABLE_ORDER_DUPLICATES = (payableId: number) =>
  `${PAYABLES_BASE_URL}/${payableId}/has-duplicate/`;
//#endregion

//#region Receivables
export const RECEIVABLES_BASE_URL = '/api/receivable';
export const RECEIVABLE = (receivableId: number) =>
  `${RECEIVABLES_BASE_URL}/${receivableId}/`;
export const RECEIVABLE_EVENTS_URL = (
  receivableId: number,
  eventName: string
) => `${RECEIVABLES_BASE_URL}/${receivableId}/sm_${eventName}/`;
export const RECEIVABLE_ERRORS_URL = (
  receivableId: number,
  eventName: string
) => `${RECEIVABLES_BASE_URL}/${receivableId}/sm_can_${eventName}/`;
export const RECEIVABLE_AI_BANK_ACCOUNT_DETECTION = (receivableId: number) =>
  `/api/v2/receivable/${receivableId}/bank-account-detection/`;
export const RECEIVABLE_ORDER_DUPLICATES = (receivableId: number) =>
  `${RECEIVABLES_BASE_URL}/${receivableId}/has-duplicate/`;
//#endregion

//#region Invoices
export const GET_INVOICE_BY_ID = (invoiceId: number) =>
  `/api/order/invoices/${invoiceId}/`;
export const ORDER_INVOICES_URL = (orderId: number) =>
  `/api/order/${orderId}/invoices/`;
//#endregion

//#region Companies
export const COMPANIES_BASE_URL = '/api/companies';
export const COMPANY_ONBOARDING_STATUSES = (companyId: number) =>
  `${COMPANIES_BASE_URL}/${companyId}/onboarding-statuses/`;
export const COMPANY_FEES = (companyId: number) =>
  `${COMPANIES_BASE_URL}/${companyId}/pricing/`;
export const COMPANY_ATTORNEY = (companyId: number) =>
  `${COMPANIES_BASE_URL}/${companyId}/power_of_attorneys/`;
export const REMAINING_LIMIT = (companyId: number) =>
  `${COMPANIES_BASE_URL}/${companyId}/available-limits/v2/`;
export const COMPANY_STATUSES = (companyId: number) =>
  `${COMPANIES_BASE_URL}/${companyId}/company-statuses/`;
export const UPDATE_COMPANY_MAIN_CONTACT = (companyId: number) =>
  `${COMPANIES_BASE_URL}/${companyId}/update-main-contact/`;
export const DOES_COMPANY_EXIST = `${COMPANIES_BASE_URL}/company_exists/`;
//#endregion

//#region Notifications
export const NOTIFICATIONS_BASE_URL = '/api/notifications';
//#endregion

//#region Wallet
export const WALLET_BASE_URL = '/api/wallet';
export const WALLET_ACCOUNTS_BASE_URL = `${WALLET_BASE_URL}/accounts`;
export const WALLET_ENTITIES = (country: string, orgNumber: string) =>
  `${WALLET_BASE_URL}/entities/${country}/${orgNumber}/`;
export const WALLET_ACCOUNT = (
  country: string,
  orgNumber: string,
  accountType: string
) =>
  `${WALLET_BASE_URL}/entities/${country}/${orgNumber}/accounts/${accountType}/`;
export const WALLET_ACCOUNT_BALANCES = (accountId: string) =>
  `${WALLET_ACCOUNTS_BASE_URL}/${accountId}/balance/`;
export const WALLET_ACCOUNT_TOTAL_BALANCE_IN_CURRENCY = (
  accountId: string,
  currency: string
) => `${WALLET_ACCOUNTS_BASE_URL}/${accountId}/total_balance/${currency}/`;
export const WALLET_GLOBAL_ACCOUNTS_BY_CURRENCY = (
  accountId: string,
  currency: string
) => `${WALLET_ACCOUNTS_BASE_URL}/${accountId}/global_accounts/${currency}/`;
export const CURRENCY_WALLET_BALANCE = (accountId: string, currency: string) =>
  `${WALLET_ACCOUNTS_BASE_URL}/${accountId}/balance/${currency}/`;
export const WALLET_ACCOUNT_BALANCES_HISTORY = (accountId: string) =>
  `${WALLET_ACCOUNTS_BASE_URL}/${accountId}/balance_history/`;
export const WALLET_ACCOUNT_HELD_BALANCES_HISTORY = (accountId: string) =>
  `${WALLET_ACCOUNTS_BASE_URL}/${accountId}/held_balance_history/`;
export const WALLET_DEPOSIT_ALLOWED_CURRENCIES = (accountId: string) =>
  `${WALLET_ACCOUNTS_BASE_URL}/${accountId}/deposit_allowed_currencies/`;
export const WALLET_CANCEL_PENDING_ACTION = (id: number) =>
  `${WALLET_BASE_URL}/action/${id}/cancel/`;
export const WALLET_REJECT_PENDING_ACTION = (id: number) =>
  `${WALLET_BASE_URL}/action/${id}/reject/`;
export const GET_BANK_STATEMENTS_LETTER = (accountId: string) =>
  `${WALLET_BASE_URL}/accounts/${accountId}/global_accounts/statements/`;
export const GET_GLOBAL_ACCOUNT_STATEMENT_LETTER = (globalAccountId: string) =>
  `${WALLET_BASE_URL}/global_accounts/${globalAccountId}/statement/`;
//#endregion

//#region Suppliers
export const SUPPLIERS_BASE_URL = '/api/supplier';
export const UPDATE_SUPPLIER = (supplierId: number) =>
  `${SUPPLIERS_BASE_URL}/${supplierId}/`;
//#endregion

//#region Customers
export const CUSTOMERS_BASE_URL = '/api/customer';
export const UPDATE_CUSTOMER = (customerId: number) =>
  `${CUSTOMERS_BASE_URL}/${customerId}/`;
export const GET_CUSTOMER_AVAILABLE_LIMITS = (customerId: number) =>
  `${CUSTOMERS_BASE_URL}/${customerId}/available-limits/`;
//#endregion

//#region Company
export const COMPANY_BASE_URL = '/api/company';
export const CORE_COMPANY = (country: string, org_no: string) =>
  `${COMPANY_BASE_URL}/${country}/${org_no}/`;
//#endregion

//#region Credit
export const CREDIT_BASE_URL = '/api/credit';
//#endregion

//#region Documents
const DOCUMENTS_BASE_URL = (documentableType: string, documentableId: number) =>
  `/api/${documentableType}/${documentableId}/documents`;
export const ORDER_DOCUMENTS = (
  documentableType: OrderType,
  documentableId: number
) =>
  `${DOCUMENTS_BASE_URL(
    DOCUMENTABLE_TYPE_MAP[documentableType],
    documentableId
  )}/`;
export const COMPANIES_DOCUMENTS = (companyId: number) =>
  `${DOCUMENTS_BASE_URL('companies', companyId)}/`;
export const UPDATE_COMPANIES_DOCUMENTS = (
  companyId: number,
  documentId: number
) => `${DOCUMENTS_BASE_URL('companies', companyId)}/${documentId}/`;
export const DOCUMENTS_REQUEST_SIGNATURE = (
  documentableType: OrderType | 'companies',
  documentableId: number,
  documentId: number
) =>
  `${DOCUMENTS_BASE_URL(
    documentableType,
    documentableId
  )}/${documentId}/request_signature/`;
export const DOCUMENTS_RESEND_EMAILS = (
  documentableType: OrderType | 'companies',
  documentableId: number,
  documentId: number
) =>
  `${DOCUMENTS_BASE_URL(
    documentableType,
    documentableId
  )}/${documentId}/resend_emails/`;

export const GET_DOCUMENT_BY_ID = ({
  documentableType,
  documentableId,
  documentId,
}: {
  documentableType: OrderType | 'companies';
  documentableId: number;
  documentId: number;
}) => `${DOCUMENTS_BASE_URL(documentableType, documentableId)}/${documentId}/`;
//#endregion
